const strings = {
  labels: {
    verified: 'Coordinates Verified',
    notVerified: 'Coordinates unverified, click here to validate',
    noResults: "Can't verify coordinates, enter manually",
    tooltip: 'Address Coordinates are used for Dispatch tracking.',
  },
} as const;

export default strings;
